import React from "react";
import styles from "../Styles/Baseinformation.module.css";
import IconWizard from '../Images/IconWizard';
import ChatAgentUI from "../Components/ChatAgentUI";

function Chatbot({ user }) {
  return (
     <div className={styles.page}>
    <div className={styles.container}>
      <div className={styles.titleRow}>
        <div className={styles.titleLeft}>
            <IconWizard />
        <h1>Talonyhtiöapuri</h1>
        </div>
      </div>
      <div style={{ padding: 10 }}>
        <ChatAgentUI />
      </div>
    </div>
    </div>
  );
}

export default Chatbot;

